<template>
  <div id="follow_us">
    <van-row>
      <van-col span="24">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              :title="$t('title.follow_us')"
              safe-area-inset-top
              @click-left="onClickLeft"
          />
        </van-col>
      </van-col>
      <van-col span="24" class="follow_us_list">
        <van-col span="24" class="follow_us_list_logo">
         <img :src="logo"/>
        </van-col>
        <van-col span="20" offset="2" class="follow_us_list_stay follow_us_list_stay_name">
          StayUpdated with<br/>{{ app_name }} Official
        </van-col>
        <van-col span="20" offset="2" class="follow_us_list_text"> {{ $t('column.boost_your_earnings_swiftly') }} </van-col>
        <van-list>
          <van-cell v-for="(item,i) in list" :key="i">
            <van-col span="22" offset="1" class="follow_us_list_item">
              <van-col span="5" class="follow_us_list_item_img">
                <img :src="item.img"/>
              </van-col>
              <van-col span="14" class="follow_us_list_item_center">
                <van-col span="24" class="follow_us_list_item_center_name"> {{ item.title }} </van-col>
                <van-col span="24" class="follow_us_list_item_center_text"> {{ item.Introduction }} </van-col>
              </van-col>
              <van-col span="5" class="follow_us_list_item_btn">
                <van-button color="#FF61F5" size="small" @click="jumpBtn(item)"> {{ $t('column.follow') }} </van-button>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>

    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Dialog, Toast} from "vant";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
      list: [],
      logo: undefined,
      app_name: undefined,
    }
  },
  created () {
    this.convert()
  },
  methods: {
    //跳转
    jumpBtn(item) {
      if (item.url) {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          window.webkit.messageHandlers.jump_url.postMessage(item.url)
        } else {
          window.AndroidJs.jump_url(item.url)
        }
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    convert() {
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=follow_us", {
        params : {
          token: token
        }
      }).then(res =>{
        // 加载状态结束
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = res.data.data.list
        this.logo = res.data.data.app_logo
        this.app_name = res.data.data.app_name
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/follow_us.vue